import React from "react";
import SingleProjectLayer from "../components/SingleProjectLayer";

const SingleProjectPage = () => {
  return <SingleProjectLayer />;
};

export default SingleProjectPage;
